var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowVod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "81.000000pt",
    height: "197.000000pt",
    viewBox: "0 0 111.000000 197.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,197.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676 1796 c-36 -15 -489 -775 -489 -821 0 -21 66 -143 230 -420 247 -419 259 -434 312 -404 39 22 52 56 37 93 -7 17 -104 186 -216 375 -112 190 -203 349 -203 355 0 6 96 173 213 371 134 227 213 370 213 387 1 52 -48 84 -97 64z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowVod);
export default __webpack_public_path__ + "static/media/leftArrowVod.7407956edb792c7e815f5b2fa6d036ce.svg";
export { ForwardRef as ReactComponent };